export default {
    login_register: 'Connexion/Inscription',
    booking_confirmation_title: 'Confirmation de réservation',
    booking_confirmation_body: 'Merci pour votre réservation. Veuillez trouver les détails de confirmation ci-dessous.',
    insurance_requirements_modal_disclaimer: `En effectuant cette réservation, je confirme que : je n'ai eu aucune condamnation ou infraction routière au cours des 5 dernières années. Je n'ai pas eu de proposition refusée, de police annulée ou de renouvellement refusé, ni été tenu de payer une prime plus élevée ou d'avoir des conditions spéciales imposées par un assureur automobile. Je n'ai pas été interdit de conduire. Je n'ai aucune poursuite ou enquête policière en cours. Je n'ai aucune condamnation pour vol, fraude ou malhonnêteté au cours des 5 dernières années. Je ne souffre pas de troubles de la vision ou de l'audition (non corrigés par des lunettes ou un appareil auditif), de troubles cardiaques, de diabète, de crises ou de toute infirmité physique ou mentale. Je n'ai eu aucun accident au cours des 5 dernières années. Veuillez cliquer sur {0} si vous ne remplissez pas ces conditions.`,
    insurance_requirements_here: 'ici',
    insurance_requirements: "J'ai lu et compris les {0}",
    ir: "Exigences d'assurance",
    location: 'Lieu',
    pickup_location: 'Lieu de prise en charge',
    dropoff_location: 'Lieu de restitution',
    vehicle: 'Véhicule',
    pickup_and_dropoff: 'Prise en charge et restitution (heure locale)',
    view_voucher: 'Voir le bon',
    identity_verification_body: 'Vous devrez vérifier votre identité avant de récupérer le véhicule',
    identity_verification_title: "Vérifier l'identité",
    search_again: 'Rechercher à nouveau',
    refrigerated: 'réfrigéré',
    aircon_lower: 'climatisation',
    aircon: 'Climatisation',
    refrigeration: 'Réfrigéré',
    not_available: "Drive & Go est actuellement disponible uniquement pour les personnes disposant de documents d'identité et de permis de conduire des pays suivants.",
    check_if_included: 'Vérifiez si votre pays est inclus.',
    included_in_booking: 'Inclus dans cette réservation',
    cdw_with_excess: 'CDW avec franchise',
    theft_protection: 'Protection contre le vol avec franchise',
    risk_reduction: 'Réduction des risques',
    free_extras: 'Vous avez droit à deux options gratuites <br /> avec cette réservation.',
    continue: 'Continuer',
    luggage_large_short_label: 'G',
    luggage_medium_short_label: 'M',
    luggage_small_short_label: 'P',
    luggage_large_long_label: 'grand',
    luggage_medium_long_label: 'moyen',
    luggage_small_long_label: 'petit',
    fuel_unspecified_label: 'non spécifié',
    transmission_manual_label: 'Manuelle',
    transmission_automatic_label: 'Automatique',
    make_a_booking: 'Faire une réservation',
    pickup_date: 'Date de prise en charge',
    dropoff_date: 'Date de restitution',
    driver_age: 'Conducteur entre 30 et 65 ans',
    enter_driver_age: "Veuillez saisir l'âge du conducteur",
    promo_code: 'Code promo',
    search: 'Rechercher',
    dropoff_date_cannot_be_before_pickup_date: 'La date de restitution ne peut pas être antérieure à la date de prise en charge',
    pickup_date_cannot_be_in_the_past: 'La date de prise en charge ne peut pas être dans le passé',
    pickup_time_cannot_be_in_the_past: "L'heure de prise en charge ne peut pas être dans le passé",
    dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: "L'heure de restitution doit être postérieure à l'heure de prise en charge si c'est le même jour",
    vehicle_filters: 'Filtres de véhicules',
    reset: 'Réinitialiser',
    transmission: 'Transmission',
    all: 'Tous',
    manual: 'Manuelle',
    auto: 'Automatique',
    passengers: 'Passagers',
    vehicle_type: 'Type de véhicule',
    filter: 'Filtrer',
    vehicle_search: 'Recherche de véhicule',
    edit: 'Modifier',
    no_results: 'Aucun résultat ne correspond à vos critères.',
    small_cars: 'Petites voitures',
    medium_cars: 'Voitures moyennes',
    large_cars: 'Grandes voitures',
    estate_cars: 'Breaks',
    suvs: 'SUV',
    mpvs: 'Monospaces',
    vans: 'Fourgonnettes',
    camper_vans: 'Camping-cars',
    premium: 'Premium',
    unspecified: 'non spécifié',
    large: 'grand',
    medium: 'moyen',
    small: 'petit',
    automatic: 'automatique',
    you_have_been_refunded: 'Vous avez été remboursé.',
    please_customer_service: 'Pour effectuer une réservation, veuillez contacter notre service client.',
    contact_customer_service: 'Contacter le service client',
    booking_failed: "Votre réservation n'a pas pu être traitée cette fois.",
    summary: 'Résumé',
    reforestation_and_protection: 'Soutenez la reforestation et la protection de la forêt tropicale au Costa Rica',
    cost_of_rental: 'Coût de la location',
    to_pay_now: 'À payer maintenant',
    greenheart_donation: 'Don Green Heart',
    total_cost: 'Coût total de la location',
    tc_agreement: "J'ai lu et compris les {0}.",
    tc: 'CGV',
    receive_offers: 'Je souhaite recevoir des offres spéciales par e-mail.',
    donate: 'Oui, je souhaite donner {amount}',
    pay_now: 'Payer {amount} maintenant',
    driver_details: 'Détails du conducteur',
    complete_driver_details: 'Veuillez compléter les détails du conducteur.',
    are_you_the_driver: 'Êtes-vous le conducteur ?',
    have_an_account: 'Avez-vous déjà un compte ?',
    login: 'Connexion',
    or: 'ou',
    first_name: 'Prénom du conducteur',
    last_name: 'Nom du conducteur',
    email: 'Adresse e-mail',
    phone_number: 'Numéro de téléphone portable',
    unable_to_save_driver_information: "Impossible d'enregistrer les informations du conducteur. Veuillez réessayer.",
    pay_online_now: 'Payer maintenant',
    day: 'Jour',
    choose_location: 'Choisissez un lieu',
    location_not_found: "Désolé, nous n'avons pas trouvé le lieu demandé.",
    add: 'Ajouter',
    remove: 'Supprimer',
    free_extra: 'Option gratuite',
    free: 'GRATUIT !',
    fast_track_notice: "Des restrictions d'origine des documents s'appliquent à ce service. Disponible uniquement pour les personnes avec des documents de",
    complete_booking: 'Finaliser la réservation',
    choose_card: 'Veuillez choisir une carte ou en ajouter une nouvelle.',
    add_billing_details: 'Veuillez ajouter les informations de facturation.',
    card_number: 'Numéro de carte',
    card_holder_name: 'Nom du titulaire',
    card_exp: 'MM / AA',
    card_cvc: 'CVC',
    save_card: 'Enregistrer la carte ?',
    amount_charged: 'Votre carte sera débitée de',
    payment_confirmation: 'Confirmer la réservation et payer',
    payment_methods: 'moyens de paiement disponibles',
    use_saved_card: 'x utiliser la carte enregistrée',
    use_different_card: '+ utiliser une autre carte',
    book_now: 'Réserver maintenant',
    minimum_age: 'Réservé aux plus de {age} ans',
    excess_liability: 'Franchise',
    security_deposit: 'Dépôt de garantie',
    fuel_policy: 'Politique de carburant',
    like_for_like: 'Plein pour plein',
    full_to_full: 'Plein à plein',
    miles_per_rental: '{mileage} miles gratuits par location',
    km_per_rental: '{mileage} km gratuits par location',
    unlimited_mileage: 'Kilométrage illimité',
    unlimited_mileage_km: 'Kilomètres illimités',
    non_amendable: 'Non modifiable',
    non_refundable: 'Non remboursable',
    free_cancellation_until: "Annulation gratuite jusqu'à",
    cancellation_in_line_with: 'Annulation selon',
    tcs: 'CGV',
    free_extras_on_collection: 'Deux options gratuites à la prise en charge',
    glass_and_tyres_covered: 'Vitre et pneus couverts',
    number_of_passengers: 'Nombre de passagers',
    number_of_bags: 'Nombre de bagages',
    fuel_type: 'Type de carburant',
    co2: 'CO2',
    book_type: 'Réserver {type}',
    processing: 'Traitement',
    actual_price: 'Prix réel',
    tooltip: 'Le prix en {currencyCode} est une estimation basée sur un taux de change, le prix en {currency} est contraignant.',
    deposit: 'Dépôt',
    pay_online: 'Payer maintenant',
    pay_online_without_extras: 'Prix de la location',
    extras_on_arrival: "Options à l'arrivée",
    insurance_on_arrival: "Réduction des risques - Payer à l'arrivée",
    insurance_online: 'Réduction des risques - Payer maintenant',
    extras_online: 'Options - payer maintenant',
    green_heart_donation: 'Don Green Heart',
    why_use_drive_and_go: 'Pourquoi utiliser Drive & Go ?',
    straight_to_car: 'Directement à la voiture',
    no_queues: "Pas de files d'attente",
    self_checkout: 'Enregistrement autonome',
    cant_lose_key: 'Impossible de perdre la clé',
    online_id_check: "Vérification d'identité en ligne",
    phone_as_key: 'Téléphone comme clé',
    premiumplus_benefits_includes: 'Avantages Premium Plus+ inclus',
    book_drive_go: 'Réserver Drive & Go',
    distance_allowance: 'Distance autorisée',
    duration: 'Durée',
    view_more_bookings: 'Voir plus de réservations',
    to_pay_on_arrival: "À payer à l'arrivée",
    pay_on_arrival: "Payer à l'arrivée",
    unlimited: 'Illimité',
    return_date: 'Date de retour',
    postcode: 'Code postal',
    country: 'Pays',
    drive_and_go: {
        drive_and_go: 'Drive And Go',
        available_countries: "Drive & Go est actuellement disponible uniquement pour les personnes disposant de documents d'identité et de permis de conduire des pays suivants :",
        drive_and_go_today: "Réservation Drive & Go aujourd'hui !",
        drive_and_go_shortened: 'Drive & Go',
        why_use_drive_and_go: 'Pourquoi utiliser Drive & Go ?',
        straight_to_car: 'Directement à la voiture',
        no_queues: "Pas de files d'attente",
        self_checkout: 'Enregistrement autonome',
        cannot_lose_the_key: 'Impossible de perdre la clé',
        online_id_check: "Vérification d'identité en ligne",
        phone_as_a_key: 'Téléphone comme clé',
        premium_plus_benefits_also_included: 'Avantages Premium Plus+ inclus',
        book_drive_and_go: 'Réserver Drive & Go',
    },
    car_and_camp: {
        tent_and_equipment: 'Tente et équipement',
        quick_and_easy: 'Installation rapide et facile',
        travel_freedom: 'Liberté de voyager',
        affordable_campervan_alternative: 'Alternative abordable au camping-car',
        lightweight_and_compact: 'Léger et compact',
        fully_insured: 'Entièrement assuré',
    },
    my_bookings: 'Ma réservation',
    no_bookings: 'Aucune réservation',
    my_profile: 'Mon profil',
    no_bookings_to_display: 'Aucune réservation à afficher.',
    search_great_car_rental_deals: 'Recherchez de super offres de location de voiture pour votre prochain voyage.',
    odometer_at_collection: 'Compteur kilométrique à la prise en charge',
    fuel_at_collection: 'Carburant à la prise en charge',
    start_check_in: "Commencer l'enregistrement",
    start_collection: 'Commencer la prise en charge',
    recent_bookings: 'Réservation récente',
    damage: {
        updated_damage_report_submitted: 'Un rapport de dommages mis à jour a été soumis. Un membre de notre équipe du service client vous contactera si nécessaire.',
        add_additional_damage: 'Ajouter un dommage supplémentaire',
        you_may_report_additional_damage_up_to: "Vous pouvez signaler des dommages supplémentaires jusqu'à 24h après la restitution du véhicule",
        specify_damage: 'Préciser le dommage',
        please_choose_the_area_and_type_of_damage: 'Veuillez choisir la zone et le type de dommage',
        type_of_damage: 'Type de dommage',
        is_this_more_than_5_cm: 'Est-ce plus de 5 cm ?',
        please_take_or_select_a_photo: 'Veuillez prendre ou sélectionner une photo',
        please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Veuillez prendre une photo en vous assurant que le dommage est bien visible',
        if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: " Si besoin, vous pouvez ajouter une autre photo, sélectionnez l'icône pour ajouter une photo",
        save_image: "Enregistrer l'image",
        save_images: 'Enregistrer les images',
        damage_saved_successfully: 'Dommage enregistré avec succès',
        add_photo: 'Ajouter une photo',
    },
    checkout: {
        start_collection: 'Commencer la prise en charge',
        collect_vehicle: 'Récupérer le véhicule',
        we_will_let_you_know_the_details: 'Nous vous indiquerons le lieu et les détails pour récupérer le véhicule de location.',
        inspect: 'Inspecter',
        we_will_ask_for_four_photos_from_each_corner: 'Nous demanderons quatre photos de chaque coin du véhicule ainsi que de tout nouveau dommage non déjà listé.',
        fuel_and_milage: 'Carburant & kilométrage',
        you_confirm_the_readings_at_the_start_of_your_hire: 'Vous confirmez le kilométrage et le niveau de carburant au début de la location.',
        sign: 'Signer',
        sign_the_rental_agreement: 'Signer le contrat de location.',
        away_you_go: 'Bonne route',
        you_are_free_to_take_to_the_road: 'Vous êtes prêt à prendre la route !',
        collect_your_vehicle: 'Récupérez votre véhicule',
        get_directions: "Obtenir l'itinéraire",
        hide_directions: "Masquer l'itinéraire",
        local_time: 'heure locale',
        tel: 'Tél',
        getting_to_the_location: 'Comment se rendre sur place',
        get_vehicle_details: 'Obtenir les détails du véhicule',
        view_map: 'Voir la carte',
        unlock_vehicle_and_continue: 'Déverrouiller le véhicule & continuer',
        unable_to_connect_to_vehicle: 'Impossible de se connecter au véhicule',
        we_were_unable_to_connect_to_the_vehicle_please_check: 'Impossible de se connecter au véhicule - veuillez vérifier que vous êtes à côté du bon véhicule et réessayer.',
        we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Impossible de trouver la réservation du véhicule. Veuillez réessayer plus tard.',
        odometer_and_fuel: 'Compteur & carburant',
        odometer: 'Compteur kilométrique',
        please_confirm_the_odometer_and_fuel_readings: 'Si possible, veuillez confirmer le compteur et le niveau de carburant.',
        the_odometer_field_is_required: 'Le champ compteur est obligatoire',
        and_must_be_greater_than_the_checkout_odometer: 'et doit être supérieur au compteur lors de la prise en charge',
        confirm: 'Confirmer',
        please_take_a_photo_from_each_corner_of_the_vehicle: 'Veuillez prendre une photo de chaque coin du véhicule',
        pre_existing_damage: 'Dommages existants',
        no_pre_existing_damage: 'Aucun dommage existant.',
        new_damage: 'Nouveau dommage',
        add_additional_damage: 'ajouter un dommage supplémentaire',
        no_new_damage_to_report: 'Aucun nouveau dommage à signaler',
        checkout_complete: 'Prise en charge terminée',
        start_rental: 'Commencer la location',
        congratulations_name_it_is_time_to_take_to_the_road: 'Félicitations {customer_name}, il est temps de prendre la route !',
        we_are_unable_to_complete_your_vehicle_checkout: 'Impossible de finaliser la prise en charge de votre véhicule.',
        please_do_the_following: 'Veuillez faire ce qui suit',
        remove_all_belonging_and_lock_the_vehicle: 'Retirez toutes vos affaires et verrouillez le véhicule.',
        lock_vehicle: 'Verrouiller le véhicule',
        once_you_have_contacted_customer_services: 'Une fois que vous avez contacté le service client',
        vehicle_location: 'Emplacement du véhicule',
        collect_your: 'Récupérez votre',
        from: 'De',
        key_in_glove_box: 'votre clé se trouve dans la boîte à gants',

        keyholder: {
            not_detected: 'Clé non détectée dans le porte-clés',
            not_detected_please_try_again: 'Veuillez placer votre clé dans le porte-clés, puis réessayez.',

            not_installed: 'Porte-clés non installé',
            not_installed_please_contact_customer_service: "Le porte-clés n'est pas installé, veuillez contacter le service client.",
        },
        keyring: {
            look_up_failed: 'Recherche du porte-clés échouée',
            look_up_failed_please_contact_customer_service: 'La recherche du porte-clés a échoué, veuillez contacter le service client.',
        },
        key: {
            invalid: 'Clé invalide',
            invalid_please_contact_customer_service: 'Votre clé est invalide, veuillez contacter le service client.',

            expired: 'Clé expirée',
            expired__please_contact_customer_service: 'Votre clé a expiré, veuillez contacter le service client.',
        },
    },
    checkin: {
        start_check_in: "Commencer l'enregistrement",
        vehicle_location: 'Emplacement du véhicule',
        tell_us_where_you_have_parked: 'Dites-nous où vous avez garé le véhicule.',
        fuel_and_milage: 'Carburant & kilométrage',
        you_confirm_the_readings_at_the_end_of_your_hire: 'Vous confirmez le compteur et le niveau de carburant à la fin de la location.',
        inspect: 'Inspecter',
        we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage:
            'Nous demanderons quatre photos de chaque coin du véhicule ainsi que de tout nouveau dommage survenu pendant la location.',
        lock: 'Verrouiller',
        check_you_have_left_no_belonging_then_lock_the_vehicle: "Vérifiez que vous n'avez rien oublié puis verrouillez le véhicule.",
        please_tell_us_where_you_have_parked_the_vehicle: 'Veuillez nous indiquer où vous avez garé le véhicule',
        once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Une fois le véhicule verrouillé, vous ne pourrez plus le déverrouiller.',
        name_please_check_you_have_left_no_belongings_then_lock_the_vehicle:
            "{first_name}, vérifiez que vous n'avez rien oublié, verrouillez le véhicule et, si nécessaire, remettez la clé physique dans le porte-clés.",
        lock_vehicle: 'Verrouiller le véhicule',
        complete_check_in: "Terminer l'enregistrement",
        inspection: 'Inspection',
        complete_vehicle_check_in: "Terminer l'enregistrement du véhicule",
        we_are_unable_to_complete_your_vehicle_check_in: "Impossible de terminer l'enregistrement de votre véhicule.",
        please_contact_customer_services: 'Veuillez contacter le service client',
        once_you_have_contacted_customer_services: 'Une fois que vous avez contacté le service client',
        please_amend_odometer_to_be_greater_than: "Veuillez modifier le compteur pour qu'il soit supérieur à {odometer_value}",
    },
    rental_agreement: {
        rental_agreement: 'Contrat de location',
        agreement_between: 'Contrat entre',
        and: 'et',
        sign_rental_agreement: 'Signer le contrat de location',
        i_have_read_and_understood_the_terms_and_conditions: "J'ai lu et compris les conditions générales et j'accepte l'état du véhicule",
    },
    additional_options: 'Options supplémentaires',
    booking_details: 'Détails de la réservation',
    price_for_x_days: 'Prix pour {qty_of_days} jour | Prix pour {qty_of_days} jours',
    cancelled: 'Annulée',
    upcoming: 'À venir',
    active: 'Active',
    full_insurance_no_deposit: 'Assurance complète & sans dépôt requis',
    excess: '{amount} franchise',
    deposit: '{amount} dépôt',
    included_daily_distance: '{distance} {unit} par jour',
    miles: 'miles',
    kilometers: 'kilomètres',
    collection_details_title: 'Détails de la prise en charge',
    collection_details_not_found: 'Aucun détail de prise en charge défini pour ce lieu',
    free_cancellation: 'Annulation gratuite',
    no_deposit: 'Sans dépôt',
    benefit_from: 'Bénéficiez de',
    for_only_per_day: 'Pour seulement {price} par jour',
    upgrade_mee: 'UpgradeMee',
};
